module.exports = __webpack_public_path__ + "img/img2.2837a403.png";